__webpack_require__.p = "/cool-zone/";